import { InfoCircleOutlined } from '@ant-design/icons';
import { Badge, Grid, Space, Spin, Tooltip, Typography } from 'antd';
import React, { Fragment } from 'react';
import LabelValidateMessage from '../../components/LabelValidateMessage';
import LogoYTexto from '../../components/LogoYTexto';
import PlanSelector from './PlanSelector';

const { useBreakpoint } = Grid;

const GroupPlanSelector = ({
  selectedCotizacion,
  selectedPlan,
  setSelectedPlan,
  setSelectedCotizacion,
  cotizaciones,
  selectedPlanTipo,
  setSelectedPlanTipo,
  setSelectedMonedaPlan,
  opcionesDePago,
  moneda,
  validacionByAseguradoraList,
  mostrarValidaciones,
  selectedMonedaPlan,
  loading
}) => {
  const screens = useBreakpoint();
  const bloquearPlanes = (cotizacion) => {
    let bloquear = !(cotizacion.autorizacionFlujo[0]
      ? !cotizacion.autorizacionFlujo[0]?.estado.includes('PENDIENTE')
      : true);

    const bloquearPorVigencia = validacionByAseguradoraList.find(
      (item) =>
        item.idAseguradora === cotizacion.aseguradoraEmpresa.aseguradora.id
    )?.bloquearPlanes;

    if (!bloquear && bloquearPorVigencia) {
      bloquear = true;
    }

    return bloquear;
  };

  const onChangePlan = (valueParam, cotizacionParam, monedaParam, tipo) => {
    if (
      selectedPlan === valueParam &&
      selectedCotizacion === cotizacionParam.id &&
      selectedMonedaPlan.codigo === monedaParam.codigo &&
      selectedPlanTipo === tipo
    ) {
      setSelectedPlan();
      setSelectedCotizacion();
      setSelectedPlanTipo();

      setSelectedMonedaPlan();
    } else {
      setSelectedPlan(valueParam);
      setSelectedCotizacion(cotizacionParam.id);
      setSelectedPlanTipo(tipo);

      setSelectedMonedaPlan(monedaParam);
    }
  };

  const selector = ({ cotizacion }) => {
    const planesEstandares = cotizacion.planes.filter(
      (item) => item.id_plan && moneda && item.id_moneda === moneda.id
    );
    const planesEspecificos = cotizacion.planes.filter(
      (item) => !item.id_plan && moneda && item.id_moneda === moneda.id
    );

    return (
      <Space direction="vertical" align="start" style={{ display: 'flex' }}>
        {planesEspecificos.length === 0 && planesEstandares.length === 0 && (
          <span>Sin planes en {(moneda && moneda.descripcion) || ''}</span>
        )}
        {planesEstandares.length > 0 && (
          <>
            <PlanSelector
              selected={
                selectedPlanTipo === 'estandar' &&
                cotizacion.id === selectedCotizacion &&
                selectedMonedaPlan &&
                moneda &&
                selectedMonedaPlan.id === moneda.id &&
                selectedPlan
              }
              onChange={(value) =>
                onChangePlan(value, cotizacion, moneda, 'estandar')
              }
              planes={planesEstandares}
              hover={!bloquearPlanes(cotizacion)}
              disabled={bloquearPlanes(cotizacion)}
              tituloAdicional="Detalle de Coberturas - Estándar"
              vehiculo={cotizacion.vehiculo}
              opcionesDePago={opcionesDePago}
              moneda={moneda}
            />
          </>
        )}
        {planesEspecificos.length > 0 && (
          <>
            <PlanSelector
              selected={
                selectedPlanTipo === 'especifico' &&
                cotizacion.id === selectedCotizacion &&
                selectedMonedaPlan &&
                moneda &&
                selectedMonedaPlan.id === moneda.id &&
                selectedPlan
              }
              onChange={(value) =>
                onChangePlan(value, cotizacion, moneda, 'especifico')
              }
              planes={planesEspecificos}
              hover={!bloquearPlanes(cotizacion)}
              disabled={bloquearPlanes(cotizacion)}
              tituloAdicional="Detalle de Coberturas - Específico"
              vehiculo={cotizacion.vehiculo}
              opcionesDePago={opcionesDePago}
              moneda={moneda}
            />
          </>
        )}
      </Space>
    );
  };

  return (
    <div
      style={{
        minHeight: 50
        // overflowX: 'auto'
        // display: `${screens && screens.md === true && 'inline-block'}`
      }}
    >
      <Spin tip="Cargando datos..." spinning={loading} delay={500} size="large">
        {cotizaciones && cotizaciones.length > 0 ? (
          cotizaciones.map((cotizacion) => (
            <Fragment key={cotizacion.id}>
              {screens && screens.md === true && (
                <>
                  <div
                    key={cotizacion.id}
                    style={{
                      textAlign: 'left'
                    }}
                  >
                    <LogoYTexto
                      logo={`/images/aseguradoras/${cotizacion.aseguradoraEmpresa.aseguradora.codigo}.png`}
                      texto={
                        cotizaciones &&
                        cotizaciones.length > 0 &&
                        cotizacion.aseguradoraEmpresa.aseguradora.nombre
                      }
                    />
                    <br />
                    {((cotizacion.autorizacionFlujo[0] &&
                      cotizacion.autorizacionFlujo[0].estado.includes(
                        'PENDIENTE'
                      )) ||
                      mostrarValidaciones) && (
                      <Space direction="vertical" style={{ paddingBottom: 4 }}>
                        {cotizacion.autorizacionFlujo[0] &&
                          cotizacion.autorizacionFlujo[0].estado.includes(
                            'PENDIENTE'
                          ) && (
                            <Badge
                              align="left"
                              color="red"
                              status="processing"
                              text={
                                <Typography.Text strong>
                                  Esta cotización está pendiente de autorización
                                </Typography.Text>
                              }
                            />
                          )}

                        {mostrarValidaciones && (
                          <>
                            {validacionByAseguradoraList.find(
                              (item) =>
                                item.idAseguradora ===
                                  cotizacion.aseguradoraEmpresa.aseguradora
                                    .id && item.mostrarAlerta
                            ) ? (
                              <Space>
                                <div style={{ textAlign: 'start' }}>
                                  <LabelValidateMessage
                                    message={
                                      validacionByAseguradoraList.find(
                                        (item) =>
                                          item.idAseguradora ===
                                          cotizacion.aseguradoraEmpresa
                                            .aseguradora.id
                                      ).mensaje
                                    }
                                    type="warning"
                                    hidden
                                  />
                                </div>
                                <div style={{ textAlign: 'start' }}>
                                  <Tooltip title="Los datos ingresados se encuentran fuera del rango permitido para esta Aseguradora. Por este motivo la solicitud quedará sujeta a autorización">
                                    <InfoCircleOutlined
                                      style={{ color: 'rgba(0,0,0,.45)' }}
                                    />
                                  </Tooltip>
                                </div>
                              </Space>
                            ) : (
                              <>
                                <div style={{ textAlign: 'start' }}>
                                  <LabelValidateMessage
                                    message={
                                      validacionByAseguradoraList.find(
                                        (item) =>
                                          item.idAseguradora ===
                                          cotizacion.aseguradoraEmpresa
                                            .aseguradora.id
                                      ).mensaje
                                    }
                                    type="secondary"
                                    hidden
                                  />
                                </div>
                              </>
                            )}
                          </>
                        )}
                      </Space>
                    )}
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-start',
                      alignItems: 'center'
                    }}
                  >
                    <div key={cotizacion.id} style={{ overflowX: 'auto' }}>
                      {cotizacion.planes &&
                        cotizacion.planes.length > 0 &&
                        selector({ cotizacion })}
                    </div>
                  </div>
                  <br />
                  <br />
                </>
              )}

              {screens && screens.md === false && (
                <>
                  <table style={{ margin: 'auto' }}>
                    <tbody>
                      <tr>
                        <td
                          style={{
                            textAlign: 'center'
                          }}
                        >
                          <LogoYTexto
                            logo={`/images/aseguradoras/${cotizacion.aseguradoraEmpresa.aseguradora.codigo}.png`}
                            texto={
                              cotizaciones &&
                              cotizaciones.length > 0 &&
                              cotizacion.aseguradoraEmpresa.aseguradora.nombre
                            }
                          />
                        </td>
                      </tr>
                      {((cotizacion.autorizacionFlujo[0] &&
                        cotizacion.autorizacionFlujo[0].estado.includes(
                          'PENDIENTE'
                        )) ||
                        mostrarValidaciones) && (
                        <tr>
                          <td
                            style={{
                              padding: '10px'
                            }}
                          >
                            <div key={cotizacion.id}>
                              {cotizacion.autorizacionFlujo[0] &&
                                cotizacion.autorizacionFlujo[0].estado.includes(
                                  'PENDIENTE'
                                ) && (
                                  <Badge
                                    align="left"
                                    color="red"
                                    status="processing"
                                    text={
                                      <span style={{ fontWeight: 'bold' }}>
                                        Esta cotización está pendiente de
                                        autorización
                                      </span>
                                    }
                                  />
                                )}
                              {mostrarValidaciones && (
                                <>
                                  {validacionByAseguradoraList.find(
                                    (item) =>
                                      item.idAseguradora ===
                                        cotizacion.aseguradoraEmpresa
                                          .aseguradora.id && item.mostrarAlerta
                                  ) ? (
                                    <Space>
                                      <div style={{ textAlign: 'start' }}>
                                        <LabelValidateMessage
                                          message={
                                            validacionByAseguradoraList.find(
                                              (item) =>
                                                item.idAseguradora ===
                                                cotizacion.aseguradoraEmpresa
                                                  .aseguradora.id
                                            ).mensaje
                                          }
                                          type="warning"
                                          hidden
                                        />
                                      </div>
                                      <div style={{ textAlign: 'start' }}>
                                        <Tooltip title="Los datos ingresados se encuentran fuera del rango permitido para esta Aseguradora. Por este motivo la solicitud quedará sujeta a autorización">
                                          <InfoCircleOutlined
                                            style={{ color: 'rgba(0,0,0,.45)' }}
                                          />
                                        </Tooltip>
                                      </div>
                                    </Space>
                                  ) : (
                                    <Space>
                                      <div style={{ textAlign: 'start' }}>
                                        <LabelValidateMessage
                                          message={
                                            validacionByAseguradoraList.find(
                                              (item) =>
                                                item.idAseguradora ===
                                                cotizacion.aseguradoraEmpresa
                                                  .aseguradora.id
                                            ).mensaje
                                          }
                                          type="secondary"
                                          hidden
                                        />
                                      </div>
                                    </Space>
                                  )}
                                </>
                              )}
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <div key={cotizacion.id}>
                    {cotizacion.planes &&
                      cotizacion.planes.length > 0 &&
                      (() => {
                        const planesEstandares = cotizacion.planes.filter(
                          (item) =>
                            item.id_plan &&
                            moneda &&
                            item.id_moneda === moneda.id
                        );
                        const planesEspecificos = cotizacion.planes.filter(
                          (item) =>
                            !item.id_plan &&
                            moneda &&
                            item.id_moneda === moneda.id
                        );
                        return (
                          <Space
                            direction="vertical"
                            align="start"
                            style={{ display: 'grid' }}
                          >
                            {planesEspecificos.length === 0 &&
                              planesEstandares.length === 0 && (
                                <span>
                                  Sin planes en{' '}
                                  {(moneda && moneda.descripcion) || ''}
                                </span>
                              )}
                            {planesEstandares.length > 0 && (
                              <div style={{ display: 'grid' }}>
                                <PlanSelector
                                  selected={
                                    selectedPlanTipo === 'estandar' &&
                                    cotizacion.id === selectedCotizacion &&
                                    selectedMonedaPlan &&
                                    moneda &&
                                    selectedMonedaPlan.id === moneda.id &&
                                    selectedPlan
                                  }
                                  onChange={(value) =>
                                    onChangePlan(
                                      value,
                                      cotizacion,
                                      moneda,
                                      'estandar'
                                    )
                                  }
                                  planes={planesEstandares}
                                  hover={!bloquearPlanes(cotizacion)}
                                  disabled={bloquearPlanes(cotizacion)}
                                  tituloAdicional="Detalle de Coberturas - Estándar"
                                  vehiculo={cotizacion.vehiculo}
                                  opcionesDePago={opcionesDePago}
                                  moneda={moneda}
                                />
                              </div>
                            )}
                            {planesEspecificos.length > 0 && (
                              <div style={{ display: 'grid' }}>
                                <PlanSelector
                                  selected={
                                    selectedPlanTipo === 'especifico' &&
                                    cotizacion.id === selectedCotizacion &&
                                    selectedMonedaPlan &&
                                    moneda &&
                                    selectedMonedaPlan.id === moneda.id &&
                                    selectedPlan
                                  }
                                  onChange={(value) =>
                                    onChangePlan(
                                      value,
                                      cotizacion,
                                      moneda,
                                      'especifico'
                                    )
                                  }
                                  planes={planesEspecificos}
                                  hover={!bloquearPlanes(cotizacion)}
                                  disabled={bloquearPlanes(cotizacion)}
                                  tituloAdicional="Detalle de Coberturas - Específico"
                                  vehiculo={cotizacion.vehiculo}
                                  opcionesDePago={opcionesDePago}
                                  moneda={moneda}
                                />
                              </div>
                            )}
                          </Space>
                        );
                      })()}
                  </div>
                  <br />
                  <br />
                </>
              )}
            </Fragment>
          ))
        ) : (
          <div style={{ width: '100%' }} />
        )}
      </Spin>
    </div>
  );
};

export default GroupPlanSelector;
